import { ITooltipHostStyles } from '@fluentui/react';

export const tooltipHostStylesDefault: Partial<ITooltipHostStyles> = {
  root: {
    display: 'inline-block',
  },
};
